export const removeURLParameter = (parameter: string): void => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.delete(parameter);
  const formattedQueryParams = queryParams.toString();
  const queryParamsWithPrefix = formattedQueryParams
    ? `?${formattedQueryParams}`
    : "";
  // eslint-disable-next-line edo/no-window-location-hash
  const newURL = `${window.location.pathname}${queryParamsWithPrefix}${window.location.hash}`;
  history.replaceState(null, "", newURL);
};
